import { extendTheme } from "@chakra-ui/react";
import { brandBodyGlobalStyle, brandChakraColors, brandPalette } from "./constants/brandPalette";

/**
 * NOTE: this project pins @chakra-ui/react@1.8.x, which does not support
 * Chakra v2 features like `semanticTokens` or `useColorMode().setColorMode`.
 * Dark-mode theming is therefore driven entirely via CSS variables in
 * `src/styles/brand-variables.css`, toggled by AdminThemeProvider via the
 * `data-theme` attribute on <html>. Chakra style props consume those vars
 * as raw CSS strings, e.g. `bg="var(--surface-raised)"`.
 */
export const theme = extendTheme({
  styles: {
    global: {
      body: brandBodyGlobalStyle,
    },
  },
  colors: {
    transparent: "transparent",
    brand: brandChakraColors,
    editorial: {
      primary: brandPalette.primary,
      accent: brandPalette.secondary,
      stroke: brandPalette.stone,
    },
    canvas: brandPalette.cream,
    main_font: brandPalette.taupe,
  },

  fonts: {
    heading: "Baloo 2, cursive",
    body: "Baloo 2, cursive",
  },
});
